import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;
if (!API_URL) {
  throw new Error('VITE_API_URL is not set. Please set it in your environment variables.');
}

export interface CountyData {
  name: string;
  region: string;
  climate: {
    temperature: string;
    rainfall: string;
    altitude: string;
  };
  mainCrops: string[];
  governmentRequirements: {
    licenses: string[];
    permits: string[];
    regulations: string[];
  };
  marketPrices: {
    commodity: string;
    price: number;
    unit: string;
    date: string;
  }[];
  farmingTips: {
    category: string;
    tips: string[];
  }[];
  resources: {
    title: string;
    url: string;
    description: string;
  }[];
  lastUpdated: Date;
  dataSource?: string;
  sourceCitations?: string[];
}

export interface CropData {
  cropName: string;
  countyData: Record<string, number>;
  nationalAverage: number;
  internationalComparison: Record<string, number>;
  marketTrend: Array<{month: string, price: number}>;
  growingConditions: Record<string, string>;
  bestPractices: string[];
  dataSource: string;
  sourceCitations?: string[];
}

export const countyService = {
  async getAllCounties(): Promise<CountyData[]> {
    try {
      const response = await axios.get(`${API_URL}/counties`);
      return response.data;
    } catch (error) {
      console.error('Error fetching counties:', error);
      throw error;
    }
  },

  async getCountyByName(name: string): Promise<CountyData> {
    try {
      const response = await axios.get(`${API_URL}/counties/${name}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching county ${name}:`, error);
      throw error;
    }
  },

  async updateCounty(name: string, data: Partial<CountyData>): Promise<CountyData> {
    try {
      const response = await axios.put(`${API_URL}/counties/${name}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating county ${name}:`, error);
      throw error;
    }
  },
  
  async getCropData(name: string): Promise<CropData> {
    try {
      const response = await axios.get(`${API_URL}/counties/crops/${name}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching crop data for ${name}:`, error);
      throw error;
    }
  }
}; 
